import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private permissions: { [permission: string]: boolean } = {};
  GetpermissionNames:any;

  constructor(
    public router: Router
  ) { }

  
  async GetUserPermission()
  {
    const encryptedUserData = localStorage.getItem('user');

    if (encryptedUserData) {
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedUserData, 'QubeAppsPro');
        const decryptedUserData = decryptedBytes.toString(CryptoJS.enc.Utf8);

        const currentUser = JSON.parse(decryptedUserData);
        // console.log(currentUser);
        if (currentUser !== null) {
          this.GetpermissionNames = currentUser
        } else {
          this.GetpermissionNames = [];
        }
        // console.log(this.GetpermissionNames);
        for (const permissionName of this.GetpermissionNames) {
          await this.setPermission(permissionName, true);
        }
        
    } else {
        this.router.navigate(['/login'], { replaceUrl: true });
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('userName');
        localStorage.removeItem('crmURL');
        localStorage.removeItem('userID');
        localStorage.removeItem('Email');
        localStorage.removeItem('domain');
        sessionStorage.removeItem('stockDataNeeded');
        sessionStorage.removeItem('addMode');
        sessionStorage.removeItem('data');
        history.pushState(null, '', location.href);
        window.onpopstate = function () {
          history.go(1);
        };
        // this.navService.LogOut();
        // this.auth.logout();
    }

  }

  
  PermissionDecline() {
    // Swal.fire({
    //   text: 'Permission Denied',
    //   icon: 'error',
    //   buttonsStyling: false,
    //   confirmButtonText: 'Ok, got it!',
    //   customClass: {
    //     confirmButton: 'btn fw-bold btn-primary',
    //   },
    // });
  }

  clearPermission(){
    this.permissions = {};
  }
  
  async setPermission(action: string, value: boolean) {
    this.permissions[action] = value;
  }

  hasPermission(action: string): boolean {
    return this.permissions[action];
  }

  //#region Dashboard
  canAccessDashboard(): boolean {
    return this.hasPermission("access dashboard") ?? false;
  }
  canCreateDashboard(): boolean {
    return this.hasPermission("create dashboard") ?? false;
  }
  canUpdateDashboard(): boolean {
    return this.hasPermission("update dashboard") ?? false;
  }
  //#endregion

  //#region Store
  canAccessStore(): boolean {
    return this.hasPermission("access store") ?? false;
  }
  canCreateStore(): boolean {
    // console.log(this.hasPermission("create store"));
    return this.hasPermission("create store") ?? false;
  }
  canUpdateStore(): boolean {
    return this.hasPermission("update store") ?? false;
  }
  canDeleteStore(): boolean {
    return this.hasPermission("delete store") ?? false;
  }

  //#endregion

  //#region Stock
  canAccessStock(): boolean {
    return this.hasPermission("access stock") ?? false;
  }
  canCreateStock(): boolean {
    return this.hasPermission("create stock") ?? false;
  }
  canUpdateStock(): boolean {
    return this.hasPermission("update stock") ?? false;
  }
  canDeleteStock(): boolean {
    return this.hasPermission("delete stock") ?? false;
  }

  //#endregion

  //#region Condiment
  canAccessCondiment(): boolean {
    return this.hasPermission("access condiment") ?? false;
  }
  canCreateCondiment(): boolean {
    return this.hasPermission("create condiment") ?? false;
  }
  canUpdateCondiment(): boolean {
    return this.hasPermission("update condiment") ?? false;
  }
  canDeleteCondiment(): boolean {
    return this.hasPermission("delete condiment") ?? false;
  }

  //#endregion

  //#region POS
  canAccessPos(): boolean {
    return this.hasPermission("access pos") ?? false;
  }
  canCreatePos(): boolean {
    return this.hasPermission("create pos") ?? false;
  }
  canUpdatePos(): boolean {
    return this.hasPermission("update pos") ?? false;
  }
  canDeletePos(): boolean {
    return this.hasPermission("delete pos") ?? false;
  }

  //#endregion

  //#region Employee
  canAccessEmployee(): boolean {
    return this.hasPermission("access employee") ?? false;
  }
  canCreateEmployee(): boolean {
    return this.hasPermission("create employee") ?? false;
  }
  canUpdateEmployee(): boolean {
    return this.hasPermission("update employee") ?? false;
  }
  canDeleteEmployee(): boolean {
    return this.hasPermission("delete employee") ?? false;
  }

  //#endregion

  //#region Customer
  canAccessCustomer(): boolean {
    return this.hasPermission("access customer") ?? false;
  }
  canCreateCustomer(): boolean {
    return this.hasPermission("create customer") ?? false;
  }
  canUpdateCustomer(): boolean {
    return this.hasPermission("update customer") ?? false;
  }
  canDeleteCustomer(): boolean {
    return this.hasPermission("delete customer") ?? false;
  }

  //#endregion

  //#region Preferences
  canAccessPreferences(): boolean {
    return this.hasPermission("access preferences") ?? false;
  }
  canCreatePreferences(): boolean {
    return this.hasPermission("create preferences") ?? false;
  }
  canUpdatePreferences(): boolean {
    return this.hasPermission("update preferences") ?? false;
  }

  //#endregion

  //#region Kitchen Printing
  canAccessKitchenPrinting(): boolean {
    return this.hasPermission("access kitchen printing") ?? false;
  }
  canCreateKitchenPrinting(): boolean {
    return this.hasPermission("create kitchen printing") ?? false;
  }
  canUpdateKitchenPrinting(): boolean {
    return this.hasPermission("update kitchen printing") ?? false;
  }
  canDeleteKitchenPrinting(): boolean {
    return this.hasPermission("delete kitchen printing") ?? false;
  }

  //#endregion

  
  //#region Miscellaneous
  canAccessMiscellaneous(): boolean {
    return this.hasPermission("access miscellaneous") ?? false;
  }
  canCreateMiscellaneous(): boolean {
    return this.hasPermission("create miscellaneous") ?? false;
  }
  canUpdateMiscellaneous(): boolean {
    return this.hasPermission("update miscellaneous") ?? false;
  }
  canDeleteMiscellaneous(): boolean {
    return this.hasPermission("delete miscellaneous") ?? false;
  }

  //#endregion
  
  //#region Reports
  canAccessReports(): boolean {
    return this.hasPermission("access reports") ?? false;
  }
  canCreateReports(): boolean {
    return this.hasPermission("create reports") ?? false;
  }
  canUpdateReports(): boolean {
    return this.hasPermission("update reports") ?? false;
  }

  //#endregion

  //#region Settings
  canAccessSettings(): boolean {
    return this.hasPermission("access settings") ?? false;
  }
  canCreateSettings(): boolean {
    return this.hasPermission("create settings") ?? false;
  }
  canUpdateSettings(): boolean {
    return this.hasPermission("update settings") ?? false;
  }
  canDeleteSettings(): boolean {
    return this.hasPermission("delete settings") ?? false;
  }

  //#endregion

  
  //#region Agent
  canAccessAgent(): boolean {
    return this.hasPermission("access agent") ?? false;
  }
  canCreateAgent(): boolean {
    return this.hasPermission("create agent") ?? false;
  }
  canUpdateAgent(): boolean {
    return this.hasPermission("update agent") ?? false;
  }
  canDeleteAgent(): boolean {
    return this.hasPermission("delete agent") ?? false;
  }

  //#endregion

  
  //#region Inventory
  canAccessInventory(): boolean {
    return this.hasPermission("access inventory") ?? false;
  }
  canCreateInventory(): boolean {
    return this.hasPermission("create inventory") ?? false;
  }
  canUpdateInventory(): boolean {
    return this.hasPermission("update inventory") ?? false;
  }
  canDeleteInventory(): boolean {
    return this.hasPermission("delete inventory") ?? false;
  }

  //#endregion

  //#region Supplier
  canAccessSupplier(): boolean {
    return true;
    return this.hasPermission("access supplier") ?? false;
  }
  canCreateSupplier(): boolean {
    return true;
    return this.hasPermission("create supplier") ?? false;
  }
  canUpdateSupplier(): boolean {
    return true;
    return this.hasPermission("update supplier") ?? false;
  }
  canDeleteSupplier(): boolean {
    return true;
    return this.hasPermission("delete supplier") ?? false;
  }

  //#endregion

  //#region Supplier
  canAccessEmenu(): boolean {
    return true;
    return this.hasPermission("access emenu") ?? false;
  }
  canCreateEmenu(): boolean {
    return true;
    return this.hasPermission("create emenu") ?? false;
  }
  canUpdateEmenu(): boolean {
    return true;
    return this.hasPermission("update emenu") ?? false;
  }
  canDeleteEmenu(): boolean {
    return true;
    return this.hasPermission("delete emenu") ?? false;
  }
  //#endregion

  //#region Housekeeping
  canAccessHousekeeping(): boolean {
    return this.hasPermission("access housekeeping") ?? false;
  }
  //#endregion
}
